import { z } from "zod";
import { ViewMode } from "../../-constant";

export const PlanDetailSearchSchema = z.object({
  // 階層ビュー等の表示モード
  viewMode: z
    .union([
      z.enum([ViewMode.HIERARCHY, ViewMode.TREE, ViewMode.TABLE]),
      z.literal("").transform(() => ViewMode.HIERARCHY),
    ])
    .optional()
    .default(ViewMode.HIERARCHY),

  // ツリー型ビュ―時のコンパクト表示
  isCompactView: z.boolean().optional().default(false),
});

export type PlanDetailSearchParams = z.infer<typeof PlanDetailSearchSchema>;
